import React from 'react';
import { string } from 'prop-types';

import './header.scss';

export const Header = ({ canonicalUrl }) => {
  let hostname;

  if (typeof window !== 'undefined' && window.location) {
    hostname = window?.location?.hostname;
  }

  if (!hostname) {
    hostname = 'homedepot.com';
  }

  return (
    <div className="reservations-header">
      <span>Check Availability</span>
      <a
        className="close-icon"
        data-testid="header-close-button"
        href={`//${hostname}${canonicalUrl}`}
        rel="noreferrer"
        aria-label="close"
      >
        <i className="mw-icon-menu-close" aria-label="close" />
      </a>
    </div>
  );
};

Header.propTypes = {
  canonicalUrl: string
};
Header.defaultProps = {
  canonicalUrl: '#'
};
